import $ from 'jquery';
import React, { useState } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { getUrlParameter } from '../../utils';
import { sendResetPasswordEmail, confirmResetPassword } from '../../api';

const refCode = getUrlParameter('ref');

const useStyles = makeStyles(theme => ({
  paper: {
    margin: theme.spacing(8, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  card: {
    margin: "0px 10px 0px 10px",
    position: 'absolute',
    top: '30%'
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  },
  progressBar: {
    margin: 'auto',
    position: 'absolute',
    top: '50%'
  }
}));

export default function Signup(props) {
  const classes = useStyles();
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [isResetRequestSent, setResetRequestSent] = useState(false);
  const { goToSignIn, mode, qtWindow, qtEngine, engine } = props;

  const changeToSignin = () => {
    window.history.replaceState("signin", "Dashboard",  qtWindow?   `/signin?client=1&engine=${qtEngine || engine}`: "/signin");
    goToSignIn();
  }

  function handleSubmit(event) {
    event.preventDefault();
    setLoading(true);

    if(mode==='reset'){
      const data = {
        email : $('#email').val(),
      };

      const onSucces = () => {
        setLoading(false);
        setResetRequestSent(true);
      }

      const onError = (xhr) => {
        let error = {}
        if (xhr.readyState === 4) {
          error = JSON.parse(xhr.responseText)
        }
        else if (xhr.readyState === 0) {
          error = {common_error: "Connection error."}
        }
        else {
          error = {common_error: "Something went wrong."}
        }
        setErrors(error)
        setLoading(false);
        setResetRequestSent(false);
      }

      sendResetPasswordEmail(data, onSucces, onError);
    }else{
      const { match } = props;
      const { token, uid } = match? match.params: {token: null, uid: null};
      const data = {
        new_password1: $('#new_password1').val(),
        new_password2: $('#new_password2').val(),
        uid,
        token
      };
      
      const onSucces = () => {
        setLoading(false);
        setErrors({});
        setResetRequestSent(true);
      }

      const onError = (xhr) => {
        let error = {}
        if (xhr.readyState === 4) {
          error = JSON.parse(xhr.responseText)
        }
        else if (xhr.readyState === 0) {
          error = {common_error: "Connection error."}
        }
        else {
          error = {common_error: "Something went wrong."}
        }
        setErrors(error)
        setLoading(false);
      }

      confirmResetPassword(data, onSucces, onError);
    }
  }

  if (loading)
    return (
      <div style={{ textAlign: 'center' }}>
        <CircularProgress className={classes.progressBar} />
      </div>
    );


  const _getView = (mode, isResetRequestSent) => {
    if (mode === 'reset' && isResetRequestSent){
      return (
        <div className={classes.card}>
          <Typography variant="h4" gutterBottom>
            We got your password reset request.
          </Typography>
          <Typography variant="subtitle2" gutterBottom>
            Please check your Email to finish this process.
          </Typography>
          <Button color="primary" variant="contained" onClick={changeToSignin}>Sign In</Button>
        </div>
      )
    }
    if (mode === 'reset' && !isResetRequestSent){
      return (
        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Reset Password
          </Typography>
          <form className={classes.form} noValidate onSubmit={handleSubmit}>
            <input
              type="hidden"
              id="referralCode"
              name="referralCode"
              value={refCode}
            />
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  id="email"
                  label="Email Address"
                  name="email"
                  autoComplete="email"
                  error={Boolean(errors.email)}
                  helperText={errors.email}
                />
              </Grid>
            </Grid>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
            >
              Reset
            </Button>
            <Grid container justify="flex-end">
              <Grid item>
                <Typography
                  color="primary"
                  variant="body2"
                  style={{ cursor: 'pointer' }}
                  onClick={changeToSignin}
                >
                  Sign In
                </Typography>
              </Grid>
            </Grid>
          </form>
        </div>
      )
    }

    if (mode !== 'reset' && !isResetRequestSent){
      return (
        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Enter a new password
          </Typography>
          <form className={classes.form} noValidate onSubmit={handleSubmit}>
            <input
              type="hidden"
              id="referralCode"
              name="referralCode"
              value={refCode}
            />
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                    id="new_password1"
                    variant="outlined"
                    type="password"
                    label="Password"
                    required
                    fullWidth
                    name="new_password1"
                    error={Boolean(errors.new_password1) || Boolean(errors.non_field_errors)}
                    helperText={errors.new_password1}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                    id="new_password2"
                    variant="outlined"
                    type="password"
                    label="Confirm Password"
                    required
                    fullWidth
                    name="new_password2"
                    error={Boolean(errors.new_password2) || Boolean(errors.non_field_errors)}
                    helperText={errors.new_password2}
                />
              </Grid>
            </Grid>
            <Typography color='error'>{errors.token? errors.token: errors.non_field_errors ? errors.non_field_errors : errors.common_error}</Typography>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
            >
              Submit
            </Button>
            <Grid container justify="flex-end">
              <Grid item>
                <Typography
                  color="primary"
                  variant="body2"
                  style={{ cursor: 'pointer' }}
                  onClick={changeToSignin}
                >
                  Back
                </Typography>
              </Grid>
            </Grid>
          </form>
        </div>
      )
    }

    if (mode !== 'reset' && isResetRequestSent){
      return (
        <div className={classes.card}>
          <Typography variant="h6" gutterBottom>
            Password successfully reset.
          </Typography>
          <Button color="primary" variant="contained" onClick={changeToSignin}>Sign In</Button>
        </div>
      )
    }
  }

  return (
    <div>
      {_getView(mode, isResetRequestSent)}
    </div>
  );
}
